/* eslint-disable no-alert */ /* eslint-disable no-nested-ternary */
<template>
  <div class="cs-payment">
    <loader ref="loader" />
    <!-- <div>
      <span class="cs-payment__welcome_text">Welcome, </span>
      <span class="cs-payment__welcome_name">
        {{userInfo.email ? userInfo.profile.firstName || userInfo.fullname : 'Guest' }}
      </span>
    </div> -->
    <!-- <div class="cs-payment__title">
        {{ $t('preview.title', {partner: title}) }}
    </div> -->
    <ShoppingList
      v-if="
        convertedCart &&
        Object.values(convertedCart).length &&
        cryptoWalletStep === 1
      "
      id="shopping-list"
      :data="convertedCart"
    />
    <!-- <div class="mb-3" v-if="isOnrampEnabled">
      <b-button block variant="primary" @click="placeOrderOnramp()">
        <img src="@/assets/img/cryptocurrency-2.svg" class="buy-icon d-inline mr-2">
        <span class="text-Underline"><ins>{{$t('payment.onramp')}}</ins> </span></b-button>
    </div> -->
    <!-- {{currentTab}} -->
    <PaymentOptionsCard
      :walletOptions="allCoins"
      :currencies="currencies"
      :convertedCart="convertedCart"
      :displayCurrency="displayCurrency"
      :isPreview="false"
      :isContinuedTransaction="isContinuedTransaction"
      :activeIndex="activeIndex"
      :cartData="cartData"
      @handleLoader="handleLoader"
      v-if="!qrData?.walletPayment"
    />
    <partial-payments v-else :qrData="qrData" :cartData="cartData" />
    <!-- eslint-disable-next-line-->
    <component is="style" scoped>
      :root { --button-default-background-color:{{
        defaultButtonBackgroundColor
      }}; --button-default-text-color:{{ defaultButtonTextColor }};
      --button-default-hover-background-color:{{
        defaultButtonHoverBackgroundColor
      }}; --button-default-hover-text-color:{{ defaultButtonHoverTextColor }};
      --button-default-outline-background-color:{{
        defaultOutlineButtonBaxAXckgroundColor
      }}; --button-default-outline-text-color:{{
        defaultOutlineButtonTextColor
      }}; }
    </component>

    <ExpiryModal
      :show="isLinkExpired"
      :title="$t('expiry-modals.linkExpired')"
      :description="$t('expiry-modals.linkDetails')"
      @closeIframe="closeIframe"
    />

    <ExpiryModal
      :show="isTransactionExpired"
      :title="$t('expiry-modals.transactionExpired')"
      :description="$t('expiry-modals.transactionDetails')"
      @closeIframe="closeIframe"
    />

    <CanceledModal
      :show="isInvoiceCancelled"
      :title="$t('expiry-modals.invoiceCanceled')"
      :description="$t('expiry-modals.invoiceCanceledDesc')"
      @closeIframe="closeIframe"
    />
  </div>
</template>

<script>
/* eslint-disable */
// @ is an alias to /src
// import * as Vue from 'vue';
import {
  SET_TAB,
  GET_EXCHANGES,
  SET_RESULT_PAGE_DATA,
  FEEDBACK_STATE,
} from "@/store/modules/user/consts";
import { mapGetters } from "vuex";
import PaymentOptionsCard from "@/components/paymentOptionCard.vue";
import ShoppingList from "@/components/ShoppingList.vue";
import ExpiryModal from "@/components/ExpiryModal.vue";
import CanceledModal from "@/components/CanceledModal.vue";

import {
  GET_USER_INFO,
  // GET_STOCKS,
  GET_SETTINGS,
  GET_CURRENCIES,
  GET_MARKET_INFO,
  // PURCHASE_CHECK,
  AUTH_EXCHANGE,
  CURRENCY_COMPARE,
} from "@/store/modules/user/consts";
import axios from "axios";
// import helper, { isUSD } from '../utils/helper';
import helper from "../utils/helper";
import { DEFAULT_CURRENCY } from "../utils/stringconsts";
import {
  CONTINUED_TRANSACTION,
  PARTIAL_PAYMENT_TRIGGER,
  PAYMENT_CONTINUED,
} from "@/utils/event.constants";
import { enableWalletConnect } from "@/utils/config";

export default {
  components: {
    PaymentOptionsCard,
    ShoppingList,
    ExpiryModal,
    CanceledModal,
  },
  data() {
    return {
      isLinkExpired: false,
      isInvoiceCancelled: false,
      isTransactionExpired: false,
      isContinuedTransaction: false,
      popup: null,
      error: "",
      stock: {},
      currentTab: {},
      coin: {},
      convertedCart: {},
      cartData: {},
      BASE_URL: process.env.VUE_APP_BASE_URL || "/api",
      count: 0,
      activeIndex: 0,
      validateBeforePayment: false,
      selectedExchangeCoin: "",
      selectedExchangeLink: "",
      qrData: null,
      resultData: {
        // eslint-disable-next-line
        icon: require("@/assets/img/success.svg"),
        title: this.$t("result.success"),
        description: this.$t("result.success-text"),
      },
    };
  },
  watch: {
    async cart() {
      if (Object.values(this.cart).length) {
        window.EventBus.emit("DELETE_INFO_MESSAGE", {
          message: "waiting cart...",
        });
        await this.getData();
        this.getcartData();
        // make this conditional
        if (!this.$route.query.code) {
          this.$refs?.loader?.end();
        }
      }
    },

    async cartConversionData(newVal) {
      let conversionRate = 1;
      let usdEquivalentRate = 1;
      if (newVal.settings?.displayCurrency !== undefined && newVal.cart) {
        // some clients do not pass cart currency
        // eslint-disable-next-line no-param-reassign
        newVal.cart.currency =
          newVal.cart?.currency !== undefined ? newVal.cart?.currency : "USD";

        const currencyToDisplay = newVal.settings?.displayCurrency;

        // If currency to display and the default currency are not equal
        if (currencyToDisplay !== DEFAULT_CURRENCY) {
          usdEquivalentRate = await this.getCurrConverRate(
            newVal.cart?.currency,
            DEFAULT_CURRENCY
          );
        }

        // Perform conversion if the currency are different
        if (
          newVal.settings?.displayCurrency.toUpperCase() !==
          newVal.cart?.currency.toUpperCase()
        ) {
          conversionRate = await this.getCurrConverRate(
            newVal.cart?.currency,
            newVal.settings?.displayCurrency
          );
        }
        this.convertedCart = JSON.parse(JSON.stringify(newVal.cart));
        this.convertedCart.usdEquivalentRate = usdEquivalentRate;
        this.convertedCart.conversionRate = conversionRate;
        this.convertedCart.displayCurrency =
          newVal.settings?.displayCurrency.toUpperCase();
      }
    },
    async selectedExchangeCoin(newVal) {
      this.validateBeforePayment = false;
      this.error = "";
      try {
        this.selectedExchangeLink = `https://www.okcoin.com/balance/withdrawal-address/${helper.getLowerCase(
          newVal.currency
        )}/0`;
        await axios.get(
          `${this.BASE_URL}/exchange/limit/${this.stock.value}?currency=${newVal.currency}&amount=${this.cart.amount}`
        );
      } catch (e) {
        this.error =
          e.response.data && e.response.data.data.message
            ? e.response.data.data.message
            : e.message;
      }
    },
  },
  async mounted() {
    // this.currentTab = 'Crypto Exchange';
    window.EventBus.emit("is-preview", false);
    this.$i18n.locale = this.$DbStorage.getItem("lang")
      ? this.$DbStorage.getItem("lang")
      : "ENG";
    this.$refs.loader.hide();
    this.$nextTick(() => {
      this.$refs.loader.start();
      // if coinbase success
      if (this.cart && Object.values(this.cart).length) {
        this.getData();
      } else {
        this.getHostedPageData();
      }
      this.$DbStorage.removeItem("rocketfuel_connect");
      window.EventBus.on(PARTIAL_PAYMENT_TRIGGER, this.getTransactionStatus);
    });
    // const resp = this.allPaymentTabs;
    // this.currentTab = resp.bank;
    this.getcartData();
  },
  computed: {
    ...mapGetters({
      cart: "user/cart",
      // conversionInfo: '/user/conversionInfo',
      stocks: "user/stocks",
      userInfo: "user/userInfo",
      settings: "user/settings",
      currencies: "user/currencies",
      displayCurrency: "user/displayCurrency",
      marketInfo: "user/marketInfo",
      paymentOptions: "user/paymentOptions",
      cryptoWalletStep: "user/getCryptoWalletStep",
      hostedPageId: "user/getHostedPageId",
    }),
    isOnrampEnabled() {
      return (
        this.marketInfo &&
        this.marketInfo.merchant &&
        this.marketInfo.merchant.isOnramp
      );
    },
    cartConversionData() {
      return { cart: this.cart, settings: this.settings };
    },
    // All coins to pay with any coin
    allCoins() {
      const coins = this.getAllCoins(this.currencies, this.paymentOptions);
      return coins;
    },
    title() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.partnerLabel
      ) {
        return this.marketInfo.whiteLabel.colorSchema.partnerLabel;
      }
      return "Rocketfuel";
    },
    defaultButtonBackgroundColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Default");
        const property = child.properties.find(
          (el) => el.name === "Background Color"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#f0833c";
    },
    defaultButtonTextColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Default");
        const property = child.properties.find(
          (el) => el.name === "Text Color"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#ffffff";
    },
    defaultButtonHoverBackgroundColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Default");
        const property = child.properties.find(
          (el) => el.name === "Background Color on hover"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#0d102a";
    },
    defaultButtonHoverTextColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Default");
        const property = child.properties.find(
          (el) => el.name === "Text Color On hover"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#ffffff";
    },
    defaultOutlineButtonBackgroundColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Outline");
        const property = child.properties.find(
          (el) => el.name === "Background Color"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#ffffff";
    },
    defaultOutlineButtonTextColor() {
      if (
        this.marketInfo &&
        this.marketInfo.whiteLabel &&
        this.marketInfo.whiteLabel.colorSchema &&
        this.marketInfo.whiteLabel.colorSchema.colors &&
        this.marketInfo.whiteLabel.colorSchema.colors.some(
          (el) => el.name === "Button"
        )
      ) {
        const section = this.marketInfo.whiteLabel.colorSchema.colors.find(
          (el) => el.name === "Button"
        );
        const child = section.children.find((el) => el.name === "Outline");
        const property = child.properties.find(
          (el) => el.name === "Text Color"
        );
        if (property && Object.keys(property).length) {
          return property.value;
        }
      }
      return "#5e72e4";
    },
  },
  methods: {
    // placeOrderOnramp() {
    //   this.setValue({ connect: 'onramp' });
    // },
    async getHostedPageData() {
      try {
        const hostedPageId = this.hostedPageId;
        if (hostedPageId) {
          this.$store.dispatch(`user/${SET_HOSTED_PAGE_INFO}`, hostedPageId);
          const resp = await this.$store.dispatch(
            `auth/${GET_HOSTED_PAGE_INFO}`,
            { id: hostedPageId }
          );
          const whitelabelResp = await this.$store.dispatch(
            `auth/${GET_WHITE_LABEL_INFO}`,
            resp.returnval
          );
          this.inheritWhiteLabel(whitelabelResp);
          this.setCartData(resp.returnval);
        } else {
          throw new Error("invalid order!");
        }
      } catch (err) {
        this.invalidOrder();
      }
    },
    inheritWhiteLabel(data) {
      // check if the iframe was whitelabeled
      if (data.whitelabelStatus != 1) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.getElementsByTagName("head")[0].appendChild(link);
        }
        link.href = data.logo;
      }
    },
    setCartData(data) {
      let rfOrder = {};
      rfOrder = data;
      rfOrder.uuid = this.$route?.params?.id;
      rfOrder.token = data?.customerInfo?.rkflToken;
      rfOrder.merchantAuth = data?.customerInfo?.merchantAuth;
      window.EventBus.emit("rocketfuel_send_cart", rfOrder);
      this.getData();
      this.$refs?.loader?.end();
    },
    async getTransactionStatus() {
      let response, txObj;
      try {
        const payload = {
          merchant_id: this.cart.merchant_id,
          offerId: this.cart.order,
          hostedPageId: this.cart.uuid,
        };
        response = await this.$store.dispatch(
          "user/GET_PREVIOUS_TRANSACTION_DATA",
          payload
        );
      } catch (error) {
        console.log(error);
        return;
      }
      // -1 No transaction
      // 0 link expire
      // 1 active
      // 2 tx expired
      // 3 Tx closed
      if (response?.tx && response?.tx?.statusRefund != 20) {
        this.$router.push({ name: "RefundRequested" });
      } else if (response?.paymentLinkStatus == -1) {
        return;
      } else if (response?.paymentLinkStatus === 1) {
        txObj = response.tx;
      } else if (response?.paymentLinkStatus === -2) {
        this.isInvoiceCancelled = true;
      } else {
        this.isLinkExpired = true;
        return;
      }
      // If stockId === null means wallet transaction
      if (!txObj) return;
      const resultData = {
        // eslint-disable-next-line
        icon: require("@/assets/img/success.svg"),
        title: this.$t("result.success"),
        description: this.$t("result.bank-success-text"),
      };
      if (txObj.stockId) {
        this.$store.dispatch(`user/${SET_RESULT_PAGE_DATA}`, resultData);
        this.$router.push({ name: "Result" });
        return;
      }

      await this.$store.dispatch(`user/${GET_USER_INFO}`);
      if (
        ["pending", "partial"].indexOf(txObj.txStatus) != -1 &&
        txObj.disablePartialSuccess &&
        !this.marketInfo.forceRefund
      ) {
        const paymentData = {
          txStatus: "partial",
          disablePartialSuccess: txObj.disablePartialSuccess,
          displayMessage: true,
        };
        resultData.paymentData = paymentData;
        this.$store.dispatch(`user/${SET_RESULT_PAGE_DATA}`, resultData);
        if (this.userInfo && this.userInfo.ssoStatus) {
          this.$router.push({
            name: "Thank",
          });
        } else {
          this.$router.push({ name: "Result" });
        }
      } else {
        switch (txObj.txStatus) {
          case "pending":
            this.isContinuedTransaction = true;
            this.continuePartialTransaction(txObj);
            break;
          case "completed":
            if (this.userInfo && this.userInfo.ssoStatus) {
              this.$router.push({
                name: "Thank",
              });
            } else {
              this.$store.dispatch(`user/${SET_RESULT_PAGE_DATA}`, resultData);
              this.$router.push({
                name: "Result",
              });
            }
            break;
          case "partial":
            this.isContinuedTransaction = true;
            this.continuePartialTransaction(txObj);
            break;
          default:
        }
      }
    },
    closeIframe() {
      this.notifyParentWindow({
        type: "rocketfuel_iframe_close",
        paymentCompleted: this.paymentCompleted,
      });
    },
    async continuePartialTransaction(txObj) {
      this.$store.dispatch(`user/${SET_TAB}`, this.$t("tabs.wallet"));
      this.$nextTick();
      this.qrData = txObj;
      if (!txObj.walletPayment) {
        setTimeout(() => {
          if (enableWalletConnect) {
            window.EventBus.emit(PAYMENT_CONTINUED, txObj);
          } else {
            window.EventBus.emit(CONTINUED_TRANSACTION, txObj);
          }
        }, 1000);
      }
    },
    getcartData() {
      if (this.cart && this.cart.cart && this.cart.cart.length) {
        this.cart.cart.forEach((v, k) => {
          this.cart.cart[k].localAmount =
            v.price *
            (this.convertedCart.conversionRate !== undefined
              ? this.convertedCart.conversionRate
              : 1);
          // eslint-disable-next-line no-nested-ternary
          this.cart.cart[k].localCurrency = this.convertedCart.displayCurrency
            ? this.convertedCart.displayCurrency
            : this.cart.currency
            ? this.cart.currency
            : "USD";
        });
        this.cartData = {
          clientId: this.cart.merchant_id,
          amount: this.cart.amount,
          // eslint-disable-next-line no-nested-ternary
          accountId: "",
          cart: this.cart.cart,
          stockId: "",
          offerId: this.cart.order,
          confirmation: this.cart.encrypted || "",
          merchantStoreCurrency: this.cart.currency,
          hostedPageId: this.cart.uuid || "",
        };
      }
    },
    async getCurrConverRate(from, to) {
      const res = await this.$store.dispatch(`user/${CURRENCY_COMPARE}`, {
        to: to.toUpperCase(),
        from: from.toUpperCase(),
      });
      if (res.status === "ok") {
        return res[to.toUpperCase()];
      }
      return 1;
    },
    async getData() {
      this.$refs?.loader?.start();
      await this.getTransactionStatus();
      try {
        const request = [
          this.$store.dispatch(`user/${GET_MARKET_INFO}`, {
            merchantId: this.cart.merchant_id,
          }),
          this.$store.dispatch(`user/${GET_CURRENCIES}`, {
            merchantId: this.cart.merchant_id,
            amount: this.cart.amount,
            currency: this.cart.currency,
          }),
          this.$store.dispatch(`user/${GET_EXCHANGES}`),
          this.$store.dispatch(`user/${GET_USER_INFO}`),
          this.$store.dispatch(`user/${GET_SETTINGS}`),
          this.$store.dispatch(`user/${FEEDBACK_STATE}`),
        ];
        await Promise.all(request);
        // this.checkStocks();
        this.setDisplayCurrency();
        this.$refs?.loader?.hide();
      } catch (err) {
        this.$refs?.loader?.hide();
      }
    },
    checkStocks() {
      if (this.$DbStorage.getItem("rocketfuel_connect_bank")) {
        this.$DbStorage.removeItem("rocketfuel_connect_bank");
        // this.tabChanged(this.allPaymentTabs.bank, 2);
      } else if (this.$DbStorage.getItem("rocketfuel_connect")) {
        if (
          this.stocks &&
          !Object.keys(this.stocks).find(
            (name) => name === this.$DbStorage.getItem("rocketfuel_connect")
          )
        ) {
          if (this.$DbStorage.getItem("rocketfuel_connect") === "coinbase") {
            this.$router.push({ name: "Connections" });
          }
        } else {
          if (this.$DbStorage.getItem("rocketfuel_connect") === "coinbase") {
            this.popup = window.open(
              "",
              "exchange_connect",
              `width=585, height=800, top=${
                (window.screen.height - 800) / 2
              }, left=${(window.screen.width - 585) / 2}, _blank`
            );
            if (this.popup) {
              this.popup.focus();
              this.popup.close();
            }

            this.popup = null;
          }
          this.$DbStorage.removeItem("rocketfuel_connect");
        }
      }
    },
    handleLoader(val) {
      if (val) {
        this.$refs.loader.start();
      } else {
        this.$refs.loader.end();
      }
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.cs-payment {
  padding: 20px 15px 15px;
  display: grid;
  gap: 10px;

  &__title {
    font-size: 20px;
    font-weight: 700;
  }

  &__text {
    font-weight: 300;
    font-size: 16px;
    line-height: 27px;
  }

  &__convert {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: $grey;
    margin-bottom: 8px;

    &_small {
      font-weight: 300;
      font-size: 14px;
      line-height: 23px;
      margin-right: 5px;
    }
  }

  &__rate {
    margin-left: 10px;
    font-weight: 600;
    font-size: 12px;
    line-height: 1;
  }

  &__total {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__you-pay {
    font-weight: 300;
    font-size: 16px;
    line-height: 27px;
  }

  &__amount {
    font-weight: 800;
    font-size: 23px;
    line-height: 38px;
    margin-left: 10px;
  }

  &__limit-exceed {
    display: flex;
    color: #ff3359;
    font-size: 15px;
    font-weight: 500;

    span {
      width: 25px;
      margin-right: 10px;
    }
  }

  &__error {
    width: 100%;
    color: #f53d3d;
    margin-bottom: -11px;
    margin-top: 15px;
    font-size: 12px;
    line-height: 1.2;
    min-height: 16px;
    font-weight: 400;
  }

  &__qr-code-info {
    display: flex;
    border: 1px solid #d7d8d6;
    padding: 12px 8px;
    border-radius: 4px;
    color: #6b7390;
    line-height: 15px;

    span {
      margin-right: 10px;

      img {
        width: 50px;
      }
    }
  }

  &__bank-info {
    display: flex;
    border: 1px solid #d7d8d6;
    padding: 12px 8px;
    border-radius: 4px;
    color: #6b7390;
    line-height: 15px;

    span {
      margin-right: 10px;

      img {
        width: 25px;
      }
    }
  }

  &__checking-payment {
    display: flex;
    color: #ff7500;
    justify-content: center;

    span {
      margin-right: 10px;

      img {
        width: 13px;
        animation: rotation 2s infinite linear;

        @keyframes rotation {
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
  }

  &__partial-payment {
    display: flex;
    color: #ff7500;
    line-height: 15px;

    span {
      margin-right: 10px;

      img {
        width: 35px;
      }
    }
  }

  &__payment-processed {
    display: flex;
    color: #42cd69;
    justify-content: center;
    align-items: center;

    div {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #42cd69;
      border-radius: 50%;
      height: 18px;
      width: 18px;
      padding: 2px;
      margin-right: 10px;

      img {
        width: 12px;
      }
    }
  }

  &__merchant-address-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &__exchange-link {
    color: #4989f4;
    cursor: pointer;
    font-size: 12px;
    margin: 0px 8px;
    text-align: center;
    width: 70%;
  }

  &__welcome {
    &_text {
      font-size: 15px;
      color: #000;
      font-weight: 600;
    }

    &_name {
      font-size: 20px;
      color: #f0833c;
      font-weight: 600;
      text-transform: capitalize;
      word-break: break-word;
    }
  }
}

.cs-qr {
  padding: 15px;
  background: $gradient-grey;
  border: 1px solid $border;
  border-radius: 1px;
  display: flex;

  &__code {
    margin-right: 15px;
    width: 135px;
    min-width: 135px;
    height: 135px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__coin-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  &__icon {
    width: 21px;
    min-width: 21px;
    height: 21px;
    object-fit: contain;
    border-radius: 50%;
    margin-right: 10px;
  }

  &__name {
    font-size: 14px;
    line-height: 17px;
  }

  &__amount {
    font-weight: 600;
    font-size: 18px;
    line-height: 21px;
  }

  &__convert {
    font-weight: 300;
    font-size: 14px;
    line-height: 23px;
    color: $black400;
    margin-bottom: 8px;
  }

  &__hr {
    width: 100%;
    height: 1px;
    background-color: $black300;
  }

  &__copy {
    width: 112px;
    height: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 1px solid $blue400;
    border-radius: 1px;
    font-size: 14px;
    line-height: 23px;
    color: $blue500;
    margin-top: auto;
    margin-left: auto;
    transition: 0.3s;

    &:hover {
      border-color: $blue500;
      color: $blue600;
    }

    &_success {
      border-color: $green500 !important;
      color: $green500 !important;
    }
  }
}

.buy-icon {
  width: 20px;
}
</style>
